var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-attributes"},_vm._l((_vm.attributes),function(attribute){return _c('div',{key:attribute.key},[_c('span',[_vm._v(_vm._s(attribute.label)+": ")]),_vm._l((attribute['options']),function(option,index){return _c('span',{key:attribute.key + index},[_vm._v(_vm._s(option.name))])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }